/**
 * ENFAMI Home — clone Netmantos /fr
 */
(function () {
  'use strict';
  if (!document.body.classList.contains('enfami-home')) return;

  var STORAGE = {
    DISMISSED: 'nm_nl_dismissed_at',
    SUBSCRIBED: 'nm_nl_subscribed',
    APPLIED: 'nm_nl_applied',
    COOKIE: 'nm_cookie_consent',
    CODE: 'WELCOME10',
    DELAY_MS: 12000,
    REOPEN_DAYS: 7
  };

  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  function initTeamCarousels() {
    document.querySelectorAll('[data-nm-team-carousel]').forEach(function (root) {
      var viewport = root.querySelector('[data-nm-team-viewport]');
      var strip = root.querySelector('[data-nm-team-strip]');
      var dotsWrap = root.querySelector('[data-nm-team-dots]');
      var prev = root.querySelector('[data-nm-team-prev]');
      var next = root.querySelector('[data-nm-team-next]');
      if (!viewport || !strip) return;

      var items = strip.querySelectorAll('.nm-club-card, .nm-nation-card');
      if (!items.length) return;

      var scrollRaf = 0;

      function scrollStep() {
        var gap = parseFloat(window.getComputedStyle(strip).gap || '12') || 12;
        return items[0].offsetWidth + gap;
      }

      function maxScroll() {
        return Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      }

      function activeIndex() {
        var sl = viewport.scrollLeft;
        var idx = 0;
        var minDist = Infinity;
        for (var i = 0; i < items.length; i++) {
          var dist = Math.abs(items[i].offsetLeft - sl);
          if (dist < minDist) {
            minDist = dist;
            idx = i;
          }
        }
        return idx;
      }

      function updateControls() {
        var sl = viewport.scrollLeft;
        var max = maxScroll();
        var canScroll = max > 2;

        root.classList.toggle('nm-team-carousel--single', !canScroll);
        if (dotsWrap) dotsWrap.hidden = !canScroll;

        if (prev) prev.disabled = !canScroll || sl <= 1;
        if (next) next.disabled = !canScroll || sl >= max - 1;

        if (dotsWrap && canScroll) {
          var current = activeIndex();
          dotsWrap.querySelectorAll('.nm-team-carousel__dot').forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === current);
          });
        }
      }

      function scrollByItems(dir) {
        viewport.scrollBy({ left: dir * scrollStep(), behavior: 'smooth' });
      }

      function goToIndex(index) {
        var i = Math.max(0, Math.min(items.length - 1, index));
        viewport.scrollTo({ left: items[i].offsetLeft, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { scrollByItems(-1); });
      if (next) next.addEventListener('click', function () { scrollByItems(1); });

      if (dotsWrap) {
        dotsWrap.querySelectorAll('[data-nm-team-dot]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            goToIndex(parseInt(btn.getAttribute('data-nm-team-dot'), 10) || 0);
          });
        });
      }

      viewport.addEventListener('scroll', function () {
        if (scrollRaf) return;
        scrollRaf = window.requestAnimationFrame(function () {
          scrollRaf = 0;
          updateControls();
        });
      }, { passive: true });

      window.addEventListener('resize', updateControls);
      updateControls();
    });
  }

  function initCarousels() {
    document.querySelectorAll('[data-nm-carousel]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-nm-track]');
      var prev = wrap.querySelector('[data-nm-prev]');
      var next = wrap.querySelector('[data-nm-next]');
      var pool = wrap.querySelector('[data-nm-lazy-pool]');
      var sentinel = wrap.querySelector('[data-nm-lazy-sentinel]');
      if (!track) return;

      function getItems() {
        return track.querySelectorAll('.nm-prod-item');
      }

      if (!getItems().length) return;

      var isAnimating = false;
      var scrollRaf = 0;
      var batchSize = parseInt(wrap.getAttribute('data-nm-batch') || '12', 10) || 12;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function getPoolTemplates() {
        if (!pool) return [];
        return Array.prototype.filter.call(pool.children, function (el) {
          return el.tagName === 'TEMPLATE';
        });
      }

      function poolRemaining() {
        return getPoolTemplates().length;
      }

      function appendLazyBatch() {
        if (!pool) return 0;
        var templates = getPoolTemplates();
        if (!templates.length) return 0;
        var n = Math.min(batchSize, templates.length);
        var sentinelEl = sentinel;
        for (var i = 0; i < n; i++) {
          var node = templates[i].content.cloneNode(true);
          if (sentinelEl && sentinelEl.parentNode === track) {
            track.insertBefore(node, sentinelEl);
          } else {
            track.appendChild(node);
          }
          templates[i].remove();
        }
        if (!poolRemaining()) {
          pool.remove();
          pool = null;
        }
        return n;
      }

      function maybeLoadMore() {
        if (!poolRemaining()) return;
        var max = maxScroll();
        var nearEnd = track.scrollLeft >= max - Math.max(120, track.clientWidth * 0.55);
        if (nearEnd) appendLazyBatch();
      }

      function maxScroll() {
        return Math.max(0, track.scrollWidth - track.clientWidth);
      }

      function activeIndex() {
        var items = getItems();
        var sl = track.scrollLeft;
        var idx = 0;
        var minDist = Infinity;
        for (var i = 0; i < items.length; i++) {
          var dist = Math.abs(items[i].offsetLeft - sl);
          if (dist < minDist) {
            minDist = dist;
            idx = i;
          }
        }
        return idx;
      }

      function updateArrows() {
        var sl = track.scrollLeft;
        var max = maxScroll();
        var canScroll = max > 2 || poolRemaining() > 0;

        wrap.classList.toggle('nm-prod-carousel--scrollable', canScroll);
        if (prev) prev.disabled = !canScroll || sl <= 1;
        if (next) next.disabled = !canScroll || (sl >= max - 1 && !poolRemaining());
      }

      function easeInOutQuart(t) {
        return t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2;
      }

      function scrollToIndex(index) {
        var items = getItems();
        var i = Math.max(0, Math.min(items.length - 1, index));
        var targetLeft = items[i].offsetLeft;

        if (reducedMotion) {
          track.scrollLeft = targetLeft;
          updateArrows();
          maybeLoadMore();
          return;
        }

        if (isAnimating) return;
        var start = track.scrollLeft;
        var delta = targetLeft - start;
        if (Math.abs(delta) < 1) return;

        isAnimating = true;
        wrap.classList.add('is-scrolling');
        /* Compromis vitesse/fluidité : ~1,05–1,35 s */
        var duration = Math.max(1050, Math.min(1350, 980 + Math.abs(delta) * 0.32));
        var startTime = null;

        function step(now) {
          if (!startTime) startTime = now;
          var progress = Math.min(1, (now - startTime) / duration);
          track.scrollLeft = start + delta * easeInOutQuart(progress);

          if (progress < 1) {
            requestAnimationFrame(step);
          } else {
            track.scrollLeft = targetLeft;
            isAnimating = false;
            wrap.classList.remove('is-scrolling');
            updateArrows();
            maybeLoadMore();
          }
        }

        requestAnimationFrame(step);
      }

      function scrollByItems(dir) {
        var items = getItems();
        var idx = activeIndex();
        if (dir > 0 && idx >= items.length - 3) appendLazyBatch();
        scrollToIndex(activeIndex() + dir);
      }

      if (prev) {
        prev.addEventListener('click', function () {
          scrollByItems(-1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          scrollByItems(1);
        });
      }

      track.addEventListener('scroll', function () {
        if (scrollRaf || isAnimating) return;
        scrollRaf = window.requestAnimationFrame(function () {
          scrollRaf = 0;
          updateArrows();
          maybeLoadMore();
        });
      }, { passive: true });

      if (sentinel && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              appendLazyBatch();
              updateArrows();
            }
          });
        }, { root: track, rootMargin: '0px 200px 0px 0px', threshold: 0 });
        io.observe(sentinel);
      }

      window.addEventListener('resize', updateArrows);
      updateArrows();
    });
  }

  function initPopup() {
    var overlay = document.getElementById('nm-nl-overlay');
    var gift = document.getElementById('nm-gift');
    var closeBtn = document.getElementById('nm-nl-close');
    var formWrap = document.getElementById('nm-nl-form-wrap');
    var successWrap = document.getElementById('nm-nl-success-wrap');
    var form = document.getElementById('nm-nl-form');
    var daySel = document.getElementById('nm-nl-day');
    var copyBtn = document.getElementById('nm-nl-copy');
    var applyBtn = document.getElementById('nm-nl-apply');
    var errEl = document.getElementById('nm-nl-error');
    var appliedMsg = document.getElementById('nm-nl-applied-msg');

    if (daySel) {
      for (var d = 1; d <= 31; d++) {
        var o = document.createElement('option');
        o.value = d < 10 ? '0' + d : '' + d;
        o.textContent = d;
        daySel.appendChild(o);
      }
    }

    function isSubscribed() { return lsGet(STORAGE.SUBSCRIBED) === '1'; }
    function shouldShow() {
      if (isSubscribed()) return false;
      var t = parseInt(lsGet(STORAGE.DISMISSED) || '0', 10);
      if (!t) return true;
      return (Date.now() - t) / (86400000) >= STORAGE.REOPEN_DAYS;
    }

    function openPopup() {
      if (!overlay) return;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
    }
    function closePopup() {
      if (!overlay) return;
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      lsSet(STORAGE.DISMISSED, String(Date.now()));
    }
    function showSuccess() {
      if (formWrap) formWrap.hidden = true;
      if (successWrap) successWrap.hidden = false;
      lsSet(STORAGE.SUBSCRIBED, '1');
      if (gift) gift.hidden = true;
    }

    function applyDiscount() {
      if (applyBtn) applyBtn.textContent = 'Application…';
      return fetch('/discount/' + STORAGE.CODE, { credentials: 'same-origin' })
        .then(function () {
          lsSet(STORAGE.APPLIED, '1');
          if (applyBtn) applyBtn.textContent = 'Appliquer 10% automatiquement';
          if (appliedMsg) appliedMsg.hidden = false;
        })
        .catch(function () {
          if (applyBtn) applyBtn.textContent = 'Appliquer 10% automatiquement';
        });
    }

    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (overlay) overlay.addEventListener('click', function (e) { if (e.target === overlay) closePopup(); });
    if (gift) {
      gift.hidden = false;
      gift.classList.add('is-visible');
      gift.addEventListener('click', openPopup);
    }

    if (form) {
      form.addEventListener('submit', function () {
        if (errEl) errEl.hidden = true;
        var submit = document.getElementById('nm-nl-submit');
        if (submit) submit.textContent = 'Envoi…';
        setTimeout(function () {
          showSuccess();
          applyDiscount();
        }, 600);
      });
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        navigator.clipboard?.writeText(STORAGE.CODE);
        copyBtn.textContent = 'Copié !';
      });
    }
    if (applyBtn) applyBtn.addEventListener('click', applyDiscount);

    if (isSubscribed()) {
      if (gift) gift.hidden = true;
    } else if (shouldShow()) {
      setTimeout(openPopup, STORAGE.DELAY_MS);
    }
  }

  function initHeaderInfo() {
    var info = document.querySelector('.nm-header-info');
    var headerCols = document.querySelector('#header-component .header__columns');
    if (info && headerCols && !headerCols.querySelector('.nm-header-info--injected')) {
      info.classList.add('nm-header-info--injected');
      headerCols.insertBefore(info, headerCols.firstChild);
    }
  }

  function initHeroSlider() {
    document.querySelectorAll('[data-ef-hero]').forEach(function (root) {
      var slides = root.querySelectorAll('[data-ef-hero-slide]');
      if (slides.length <= 1) return;

      var dots = root.querySelectorAll('[data-ef-hero-dot]');
      var prev = root.querySelector('[data-ef-hero-prev]');
      var next = root.querySelector('[data-ef-hero-next]');
      var progress = root.querySelector('[data-ef-hero-progress]');
      var autoplay = root.dataset.autoplay !== 'false';
      var interval = parseInt(root.dataset.interval || '5000', 10);
      var current = 0;
      var timer = null;
      var progStart = null;
      var raf = null;

      function goTo(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach(function (s, i) {
          s.classList.toggle('is-active', i === current);
        });
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === current);
          d.setAttribute('aria-selected', i === current ? 'true' : 'false');
        });
        if (progress) progress.style.width = '0%';
        progStart = performance.now();
      }

      function tickProgress(now) {
        if (!progress || !autoplay) return;
        var elapsed = now - progStart;
        var pct = Math.min(100, (elapsed / interval) * 100);
        progress.style.width = pct + '%';
        if (pct < 100) raf = requestAnimationFrame(tickProgress);
        else raf = null;
      }

      function startAutoplay() {
        stopAutoplay();
        if (!autoplay) return;
        progStart = performance.now();
        raf = requestAnimationFrame(tickProgress);
        timer = setInterval(function () {
          goTo(current + 1);
          progStart = performance.now();
          if (raf) cancelAnimationFrame(raf);
          raf = requestAnimationFrame(tickProgress);
        }, interval);
      }

      function stopAutoplay() {
        if (timer) clearInterval(timer);
        timer = null;
        if (raf) cancelAnimationFrame(raf);
        raf = null;
      }

      if (prev) prev.addEventListener('click', function () { goTo(current - 1); startAutoplay(); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); startAutoplay(); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(dot.dataset.efHeroDot || '0', 10));
          startAutoplay();
        });
      });

      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);

      var touchX = 0;
      root.addEventListener('touchstart', function (e) {
        touchX = e.changedTouches[0].screenX;
        stopAutoplay();
      }, { passive: true });
      root.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].screenX - touchX;
        if (Math.abs(dx) > 50) goTo(current + (dx < 0 ? 1 : -1));
        startAutoplay();
      }, { passive: true });

      startAutoplay();
    });
  }

  /* Prefetch navigation au pointerdown (perçu plus rapide sur mobile) */
  function initNavPrefetch() {
    var done = Object.create(null);
    function prefetch(href) {
      if (!href || done[href]) return;
      if (href.indexOf(window.location.origin) !== 0 && href.charAt(0) !== '/') return;
      done[href] = 1;
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = href;
      link.as = 'document';
      document.head.appendChild(link);
    }
    document.addEventListener('pointerdown', function (e) {
      var a = e.target.closest('a[href]');
      if (!a) return;
      var href = a.href;
      if (!href || a.target === '_blank' || href.indexOf('#') === href.length - 1) return;
      if (a.hasAttribute('download')) return;
      prefetch(href);
    }, { passive: true });
  }

  function boot() {
    initCarousels();
    initTeamCarousels();
    initPopup();
    initHeaderInfo();
    initHeroSlider();
    initNavPrefetch();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
